import { defineStore } from 'pinia'
import { getSettingsPage } from '@/api/mlap/settings'

/**
 * Payloads of the MLAP settings pages reached from the sidebar (connected
 * accounts, mappable options). Record data, so nothing is cached across
 * entries (ROUTER.md §4): every client-side entry fetches fresh. Filled by the
 * route `prepare` hooks so the page components read it synchronously at
 * setup via route props.
 */
export const useMlapSettingsStore = defineStore('mlapSettings', {
  state: () => ({ pages: {}, hydratedPage: null }),
  getters: {
    pageProps: (state) => (key) => state.pages[key] ?? {}
  },
  actions: {
    // Full page load: the styxie payload serves the first render, so the
    // initial navigation's `preparePage` skips the fetch exactly once.
    hydrate(key, data) {
      this.pages[key] = data
      this.hydratedPage = key
    },
    async preparePage(key) {
      if (this.hydratedPage === key) {
        this.hydratedPage = null
        return
      }

      const res = await getSettingsPage(key)
      this.pages[key] = res.data
    }
  }
})
